import { useCallback, useState } from "react";

interface ObjectDetailsPanelState {
  isOpen: boolean;
  data: any;
}

export const useObjectDetailsPanel = () => {
  const [objectDetailsPanel, setObjectDetailsPanel] =
    useState<ObjectDetailsPanelState>({
      isOpen: false,
      data: {},
    });

  const closeObjectDetailsPanel = useCallback(() => {
    setObjectDetailsPanel({
      isOpen: false,
      data: {},
    });
  }, []);

  const openObjectDetailsPanel = useCallback(({ data }: { data: any }) => {
    setObjectDetailsPanel({
      isOpen: true,
      data,
    });
  }, []);

  return {
    objectDetailsPanel,
    closeObjectDetailsPanel,
    openObjectDetailsPanel,
  };
};
